import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from "react-native";
import { observer } from "mobx-react";
import { blogCategoryStore } from "../stores/BlogCategoryStore";
import { navigate } from "../services/NavigationService";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { PlusIcon, PencilSimpleIcon, TrashIcon, FunnelSimple as FilterIcon } from "@phosphor-icons/react";
import { Theme } from "../enum/Theme";
import SpaceW from "@comps/SpaceW";
import { Language } from "@constants/language";
import { ModalFiltroLanguage } from "../comps/ModalFiltroLanguage";
import { getFlagByLanguage } from "../services/getFlagByLanguage";


const BlogCategoryList = observer(() => {
  const { categories, loading, deleteCategory } = blogCategoryStore;

  const [modalVisible, setModalVisible] = useState(false);
  const [filterLang, setFilterLang] = useState<Language | null>(null);

  const categoriesFiltered = filterLang
    ? categories.filter((cat) => cat.lang === filterLang)
    : categories;

  if (loading) {
    return <Text style={{ textAlign: "center", marginTop: 50 }}>Carregando...</Text>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <TouchableOpacity style={styles.addButton} onPress={() => navigate(EnumRoutesAppWeb.createEditCategory)}>
          <PlusIcon size={20} color="#fff" />
          <Text style={styles.addButtonText}>Nova Categoria</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.filterButton} onPress={() => setModalVisible(true)}>
          <FilterIcon size={22} color={Theme.foreground} />
        </TouchableOpacity>
      </View>

      <ScrollView>
        {categoriesFiltered.map((category) => (
          <View style={styles.row} key={category.id}>
            <View>
              <Text style={{ fontSize: 18 }}>{getFlagByLanguage(category.lang)}</Text>
            </View>
            <SpaceW />
            <Text style={styles.rowText}>{category.title}</Text>
            <SpaceW />
            <View style={styles.actions}>
              <TouchableOpacity onPress={() => navigate(EnumRoutesAppWeb.createEditCategory, { category })}>
                <PencilSimpleIcon size={20} color="#555" />
              </TouchableOpacity>
              <SpaceW />
              <TouchableOpacity onPress={() => deleteCategory(category.id)}>
                <TrashIcon size={20} color="#E57373" />
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </ScrollView>

      <ModalFiltroLanguage
        visible={modalVisible}
        value={filterLang}
        onSelect={setFilterLang}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
});

export default BlogCategoryList;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  topBar: { flexDirection: "row", alignItems: "center", marginBottom: 15 },
  addButton: { backgroundColor: Theme.foreground, padding: 10, borderRadius: 5, flexDirection: "row", alignItems: "center" },
  addButtonText: { color: "#fff", marginLeft: 5 },
  filterButton: { marginLeft: 10, padding: 7, borderRadius: 5, backgroundColor: "#e6e6e6" },
  row: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: "#ccc" },
  rowText: { flex: 2 },
  actions: { flexDirection: "row", gap: 10 },
});
